module.exports = __webpack_public_path__ + "media/images/flags/64/Colombia-5b69a7e4a313f868727991f35cf2be03.png";